import React from "react";
import styled from "styled-components";

// components
import Link from "core/Link";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";

const TextLinksStyled = styled.ul`
    color: ${colors.primary.snow};
    width: 100%;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    column-gap: ${convertPxToRem(24)};
    row-gap: ${convertPxToRem(18)};
`;

// data
import { footerMenu } from "data/links";

// component
export const TextLinks = () => {
    return (
        <TextLinksStyled>
            {footerMenu.map(link => {
                return (
                    <li key={link.name}>
                        <Link
                            href={link.href}
                            target={link.target || "_self"}
                            size="md"
                            styleType="secondary"
                            darkMode
                            disableVisitedStyle
                        >
                            {link.name}
                        </Link>
                    </li>
                );
            })}
        </TextLinksStyled>
    );
};

export default TextLinks;
